module.exports = __webpack_public_path__ + "img/commit.a60df59a.jpg";